<template>
	<div>
		<!-- 底部 -->
		<div class="service">
<!--			<img src="../../assets/img/logo.png" alt="">-->
      <div style="color: #fff; font-size: 16px; text-align: center">
        重庆云锦荣科技有限公司<br/>
        <br/>
        Chongqing Yunjinrong Technology Co., Ltd
      </div>
			<div class="service-product">
				<div>服务与产品</div>
				<div>技术咨询</div>
				<div>软件服务</div>
			</div>
			<div class="service-address">
				<div>联系我们</div>
				<div>联系地址：重庆市 渝北区 园博园 两江盛景 </div>
				<div>联系电话：18716389434</div>
			</div>
		</div>
		<!-- 备案号 -->
		<footer>
			<div><img src="../../assets/icon/record.png" alt="" class="record">云锦荣官网</div>
			<div @click="record">渝ICP备2023013621号-2</div>
			<div>
				©2018-{{year}} 
				<div>云锦荣 - 给与您的帮助，是我们最大的荣幸</div>
			</div>
		</footer>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				year:''
			}
		},
		created(){
			this.year=new Date().getFullYear()
		},
		methods:{
			record(){
				window.open('https://beian.miit.gov.cn/#/Integrated/index','_black')
			}
		}
	})
</script>

<style lang="scss" scoped>
	.service{
		background:#000;
		padding:.41rem 0;
		box-sizing: border-box;
		display:flex;
		flex-direction: column;
		align-items: center;
		>img{
			width:1.72rem;
			height:.51rem;
		}
		.service-product{
			margin:.86rem 0;
			display:flex;
			flex-direction: column;
			align-items: center;
			>div{
				font-size: 0.24rem;
				color: #AEB7C2;
				line-height: .38rem;
				margin-bottom:.14rem;
				&:nth-child(1){
					font-weight: 600;
					margin-bottom:.27rem;
					line-height: .41rem;
					color:#fff;
				}
				&:last-child{
					margin-bottom:0;
				}
			}
		}
		.service-address{
			display:flex;
			flex-direction: column;
			align-items: center;
			>div{
				font-size: 0.24rem;
				color: #AEB7C2;
				line-height: .38rem;
				margin-bottom:.27rem;
				&:nth-child(1){
					font-weight: 600;
					line-height: .41rem;
					color:#fff;
				}
				&:last-child{
					margin-bottom:0;
				}
			}
		}
	}
	footer{
		display:flex;
		flex-direction: column;
		justify-content: center;
		padding:.41rem 0;
		font-size: 0.24rem;
		line-height: .38rem;
		color: var(--main-color);
		align-items: center;
		>div{
			margin-top:.27rem;
			text-align: center;
			&:nth-child(1){
				margin-top:0;
			}
			>img{
				width:.24rem;
				height:.24rem;
				vertical-align: middle;
				margin-right:.06rem;
			}
			
		}

	}
</style>
